import React, { useState, useEffect, useRef } from 'react';
import { suggestionSearch } from '../services/index';

function ProductSearch() {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const wrapperRef = useRef(null);

  // Debounced search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (query.trim()) {
        fetchSuggestions();
      } else {
        setSuggestions([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [query]);

  const fetchSuggestions = async () => {
    try {
      setLoading(true);
      setError(null);
      const result = await suggestionSearch(query);
      setSuggestions(result?.suggestions || []);
    } catch (err) {
      setError('Failed to fetch suggestions.');
    } finally {
      setLoading(false);
    }
  };

  // Close suggestions on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setSuggestions([]);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  console.log('Suggestions:', suggestions);
  return (
    <div className="relative w-full max-w-lg" ref={wrapperRef}>
      {/* Search Bar */}
      <div className="w-full flex items-center border border-[#019c89] rounded-md px-3 py-2 shadow-sm focus-within:ring-2 focus-within:ring-[#019c89]">
        <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
        <input
          type="text"
          placeholder="Search..."
          className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {/* Suggestions Dropdown */}
      {query && suggestions.length > 0 && (
        <div className="absolute z-10 top-[100%] w-full bg-white border border-[#019c89] rounded-md mt-1 max-h-60 overflow-y-auto shadow-lg">
          {loading ? (
            <p className="px-4 py-2 text-sm text-gray-500">Loading...</p>
          ) : error ? (
            <p className="px-4 py-2 text-sm text-red-500">{error}</p>
          ) : (
            suggestions.map((item, idx) => (
              <div
                key={idx}
                className="px-4 py-2 cursor-pointer hover:bg-[#019c89]/10 text-sm text-gray-800 flex items-center justify-between"
              >
                <p>{item.equip_name || item}</p>
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <p>{item.brand || ''}</p>
                  <p>{item.asking_price || ''}</p>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default ProductSearch;
